<span class="p-input-icon-left ml-auto" *ngIf="visible">
  <i class="fa fa-search fa-fw"></i>
  <input
    pInputText
    type="text"
    [(ngModel)]="searchValue"
    (ngModelChange)="onModelChange.emit($event)"
    [placeholder]="'search' | i18next"
  />
</span>
